import type { HelpFile } from '../../types/help'
import { CertificationDashboardTestIds } from '../../../testids/CertificationDashboardTestIds'

export const certificationDashboardHelp: HelpFile = {
  docPage: '/docs/governance/certification',
  texts: {
    [CertificationDashboardTestIds.certificationDashboard]:
      'Overview of active certification campaigns, pending review tasks, and certification statistics.',
    [CertificationDashboardTestIds.certificationDashboardSummary]:
      'KPI tiles summarising campaign and review activity across the organisation.',
    [CertificationDashboardTestIds.cardActiveCampaigns]: null,
    [CertificationDashboardTestIds.cardActiveCampaignsTable]:
      'Certification campaigns currently running — drill into a row to see reviews, decisions, and progress.',
    [CertificationDashboardTestIds.cardCampaignManagement]:
      'Manager view of all campaigns — monitor coverage, status, and ownership.',
    [CertificationDashboardTestIds.cardDecisionsOverview]:
      'Review decisions across all active campaigns broken down into kept, revoked, and undecided.',
    [CertificationDashboardTestIds.cardReviewProgress]:
      'How far reviewers have progressed through their assigned items in the current period.',
    [CertificationDashboardTestIds.cardTitleActiveCampaigns]: null,
    [CertificationDashboardTestIds.cardTitleCampaignManagement]: null,
    [CertificationDashboardTestIds.kpiActiveCampaignsValue]: null,
    [CertificationDashboardTestIds.kpiDecisionsOverviewValue]: null,
    [CertificationDashboardTestIds.kpiOverdueBadge]:
      'Active campaigns that have passed their due date and still have undecided items.',
    [CertificationDashboardTestIds.kpiReviewProgressValue]: null,
    [CertificationDashboardTestIds.colCampaign]: null,
    [CertificationDashboardTestIds.colDueDate]:
      'Date by which all reviews in this campaign must be completed.',
    [CertificationDashboardTestIds.colKeep]:
      'Review items decided as kept — access remains.',
    [CertificationDashboardTestIds.colRevoked]:
      'Review items decided as revoked — access will be removed.',
    [CertificationDashboardTestIds.colUndecided]:
      'Review items still awaiting a reviewer decision.',
    [CertificationDashboardTestIds.colProgress]: null,
    [CertificationDashboardTestIds.colManagementName]: null,
    [CertificationDashboardTestIds.colManagementOwner]:
      'Identity responsible for running the campaign and following up with reviewers.',
    [CertificationDashboardTestIds.colManagementPolicy]:
      'Certification policy that produced this campaign — defines scope, reviewers, and cadence.',
    [CertificationDashboardTestIds.colManagementStatus]: null,
    [CertificationDashboardTestIds.colManagementDueDate]: null,
    [CertificationDashboardTestIds.btnCreateCampaign]:
      'Create a new certification campaign manually based on an existing certification policy.',
    [CertificationDashboardTestIds.btnGenerateCampaigns]:
      'Trigger the scheduler to generate all campaigns due based on their certification policies.',
  },
}
